import React, { Fragment,} from "react";
import { Box, TableContainer, Paper, Table, TableBody, TableCell, TableRow, } from "@mui/material";
import { EnhancedTableHead } from "../../../../components/CustomTable";
import container from "../Visit.container";
const CalendarTwo = ({ onFetchReportListStart, 
    visitScreen: {visitReportData}}) => {
    console.log("visitReportData---->", visitReportData);
    const [dense, setDense] = React.useState(false);
    type Order = "asc" | "desc";
    const [order, setOrder] = React.useState<Order>("asc");
    const [orderBy, setOrderBy] = React.useState<any>("name")

    interface HeadCell {
        disablePadding: boolean;
        id: any;
        label: string;
        isShow: boolean;
        numeric: boolean;
        align?: string;
    }
    const headCells: readonly HeadCell[] = [
        {
            id: "beat_name",
            numeric: false,
            disablePadding: true,
            label: "Beat Name",
            isShow: true,
        },
        {
            id: "distributor_name",
            numeric: false,
            disablePadding: true,
            label: "Ditributor Name",
            isShow: true,
        },
        {
            id: "retailer_name",
            numeric: false,
            disablePadding: true,
            label: "Retailer Name",
            isShow: true,
        },
        {
            id: "mobile",
            numeric: false,
            disablePadding: true,
            label: "Mobile Number",
            isShow: true,
        },
        {
            id: "visit_time",
            numeric: false,
            disablePadding: true,
            label: "Visit Time",
            isShow: true,
        },
    ]
    function convertUtcToIst(utcTimeString) {
        const utcDate = new Date(utcTimeString);
    
        const istOffset = 5 * 60 + 30; 
    
        const istTime = new Date(utcDate.getTime() + istOffset * 60 * 1000);
    
        return istTime.toLocaleString(); 
      }
    const handleRequestSort = (field) => {
        const isAsc = orderBy === field && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(field);
    };
    // React.useEffect(() => {
    //     onFetchReportListStart("2023-11-24", 35);
    // }, [])
    return(
        <Fragment>
            <Box sx = {{ overflow: "auto"}}>
                <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", }}>
                    <TableContainer component={Paper}>
                        <Table aria-labelledby="tableTitle" size={dense ? "small" : "medium"}>
                            <EnhancedTableHead
                              numSelected={0}
                              order={order}
                              orderBy={orderBy}
                              onSelectAllClick={() => {}}
                              onRequestSort={(event, property) => handleRequestSort(property)}
                              rowCount={0}
                              headCells={headCells}
                              isCheckBox = {false}
                            />
                            <TableBody>
                                {visitReportData && visitReportData.length > 0 ? (
                                    visitReportData?.map((row, index) => {
                                        return(
                                            <TableRow key={index}>
                                                <TableCell align="center" sx={{
                                                    borderTop: "1px solid #ebeded",
                                                    borderRight: "1px solid #ebeded",
                                                    borderLeft: "1px solid #ebeded", 
                                                    height: "75px",
                                                }}>
                                                  {row?.beat_name ? row?.beat_name : "-"}
                                                </TableCell>
                                                <TableCell align="center" sx={{
                                                    borderTop: "1px solid #ebeded",
                                                    borderRight: "1px solid #ebeded",
                                                    borderLeft: "1px solid #ebeded", 
                                                    height: "75px",
                                                }}>
                                                -
                                                </TableCell>
                                                <TableCell align="center" sx={{
                                                    borderTop: "1px solid #ebeded",
                                                    borderRight: "1px solid #ebeded",
                                                    borderLeft: "1px solid #ebeded", 
                                                    height: "75px",
                                                }}>
                                                  {row?.retailer_name ? row?.retailer_name : "-"}
                                                </TableCell>
                                                <TableCell align="center" sx={{
                                                    borderTop: "1px solid #ebeded",
                                                    borderRight: "1px solid #ebeded",
                                                    borderLeft: "1px solid #ebeded", 
                                                    height: "75px",
                                                }}>
                                                  {row?.mobile ? row?.mobile : "-"}
                                                </TableCell>
                                                <TableCell align="center" sx={{
                                                    borderTop: "1px solid #ebeded",
                                                    borderRight: "1px solid #ebeded",
                                                    borderLeft: "1px solid #ebeded", 
                                                    height: "75px",
                                                }}>
                                                  {convertUtcToIst(row.visit_time) ? convertUtcToIst(row?.visit_time) : "-"}
                                                </TableCell>
                                            </TableRow>)
                                        }) ) :
                                            (
                                                <TableRow>
                                                    <TableCell colSpan={headCells.length} align="center">
                                                        No Data Available
                                                    </TableCell>
                                                </TableRow>
                                            )
                                    }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        </Fragment>
    )
}

export default container(CalendarTwo);